import { getDateStringForPeriod } from 'View/schedule-generate/helper/getPeriodDay';

const getNewSubShiftTime = (metadata, targetLocation, sourceSchedule) => {
  const [newDate, newHour] = targetLocation; // [dd, hh]
  const yearMonth = metadata?.yearMonth; // yyyy-MM

  const originalStartTime = new Date(sourceSchedule.subShiftStartTime);
  const originalEndTime = new Date(sourceSchedule.subShiftEndTime);
  const shiftDuration = originalEndTime - originalStartTime;

  const dateString = getDateStringForPeriod(newDate, yearMonth);
  const newSubShiftStartTime = new Date(`${dateString} ${String(newHour).padStart(2, '0')}:00:00`);
  const newSubShiftEndTime = new Date(newSubShiftStartTime.getTime() + shiftDuration);

  return {
    newSubShiftStartTime,
    newSubShiftEndTime,
  };
};

export default getNewSubShiftTime;
